module.exports = __webpack_public_path__ + "img/boiler-N-idle.cf1d6dfb.png";